"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPollFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 8c0-1.329.667-1.995 2-2 1.333-.005 2 .662 2 2v8c0 1.333-.667 2-2 2s-2-.667-2-2V8zm6-4c0-1.333.667-2 2-2s2 .667 2 2v12c0 1.337-.667 2.003-2 2-1.333-.003-2-.67-2-2V4zM5 20h14c.667 0 1 .333 1 1s-.333 1-1 1H5c-.667 0-1-.333-1-1s.333-1 1-1zm11-8c0-1.333.667-2 2-2s2 .667 2 2v4c0 1.333-.667 2-2 2s-2-.667-2-2v-4z' }))); };
exports.default = SvgPollFilled;
//# sourceMappingURL=PollFilled.js.map